import {
    Checkbox,
    Grid,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Typography
} from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import { ResourceType } from '../../common/PricePrgClient';
import { RootState } from '../../store';
import { getSelectedUserGroup, getUserGroupPagePermissions } from './redux/userGroupSelectors';
import { setPagePermissionForGroupRequest } from './redux/userGroupSlices';
const mapStateToProps = (state: RootState) => ({
    selectedUserGroup: getSelectedUserGroup(state),
    viewPermissions: getUserGroupPagePermissions(state)
});

type Props = ReturnType<typeof mapStateToProps>;

const ManageGroupPagePermissions = ({ selectedUserGroup, viewPermissions }: Props) => {
    const dispatch = useDispatch();

    if (selectedUserGroup == null) {
        return <div />;
    }

    const handleViewPermissionClicked = (resourceType: ResourceType, hasAccess: boolean) => {
        dispatch(
            setPagePermissionForGroupRequest({
                hasAccess,
                resourceType,
                userGroupId: selectedUserGroup.userGroupId
            })
        );
    };

    return (
        <Grid
            container
            direction="column"
            sx={{
                maxWidth: 400
            }}
        >
            <Grid item>
                <Typography variant="h5">Page permissions</Typography>
                <List>
                    {viewPermissions.map(vp => (
                        <ListItem key={vp.resourceType} dense>
                            <ListItemText primary={vp.readableName} />
                            <ListItemSecondaryAction>
                                <Checkbox
                                    onChange={() =>
                                        handleViewPermissionClicked(vp.resourceType, !vp.hasAccess)
                                    }
                                    checked={vp.hasAccess}
                                />
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
            </Grid>
        </Grid>
    );
};

export default connect(mapStateToProps)(ManageGroupPagePermissions);
